import { EntityName, Page } from '@/components';
import { tokensMapping } from '@/utils/tokens';
import { CryptoIcon, Heading } from '@blockanalitica/ui';
import DSREventsTable from './DSREventsTable';
import DSRVolumeChart from './DSRVolumeChart';

export default function DSRActivityPage() {
  return (
    <Page
      title={
        <EntityName
          symbol1={
            <CryptoIcon
              name={'DAI'}
              address={tokensMapping('DAI').address}
              size="4"
            />
          }>
          <Heading size="1">DAI Savings Rate Activity</Heading>
        </EntityName>
      }>
      <DSRVolumeChart />
      <DSREventsTable />
    </Page>
  );
}
